import React from 'react';
import styles from './style.module.scss';

export default function RadioGroup({
  options,
  name,
  value,
  onChange,
  onClick,
  children,
  className,
  labelClassName,
  inputClassName,
  ...otherProps
}) {
  let parsedOptions = options || [];
  let otherChildren;
  if (children) {
    const childrenArray = Array.isArray(children) ? children : [children];
    if (childrenArray.length > 0) {
      parsedOptions = childrenArray
        .filter((node) => node.type === 'option')
        .map((node) => ({
          value: node.props.value,
          name: node.props.children,
          ...node.props,
        }));
      otherChildren = childrenArray.filter((node) => node.type !== 'option');
    }
  }
  return (
    <div className={`${styles.container} ${className || ''}`} {...otherProps}>
      {parsedOptions.map((option, index) => [
        <input
          type="radio"
          name={name}
          value={option.value}
          className={inputClassName}
          id={`option-${name}-${index}`}
          onChange={onChange}
          onClick={onClick}
          checked={value === option.value}
          key={`option-input-${option.value}`}
          data-jest={option['data-jest']}
        />,
        <label
          className={labelClassName}
          htmlFor={`option-${name}-${index}`}
          key={`option-label-${option.value}`}
          data-qa={option['data-qa']}
        >
          {option.name}
        </label>,
      ])}
      {otherChildren}
    </div>
  );
}
